import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useDistributorAuth, redirectToManage } from '../auth/useDistributorAuth';
import { useEffect } from 'react';

export const Route = createFileRoute('/distributor')({
  component: DistributorLayout,
});

function DistributorLayout() {
  const { isAuthenticated } = useDistributorAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      redirectToManage();
    }
  }, [isAuthenticated]);

  if (!isAuthenticated) {
    return null;
  }

  return <Outlet />;
}
